import { Dtos } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { agentPreviewsQueryKey, agentUserPreviewsQueryKey } from "../user.keys";

export const useInviteAgentUser = () => {
	const { get, post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationKey: ["inviteAgentUser"],
		mutationFn: async (data: Dtos.Agent.Invite.Request) => {
			await post("/v2/agents/invite", data, "none");
		},
		onSuccess: async () => {
			queryClient.invalidateQueries({ queryKey: agentUserPreviewsQueryKey() });
			const updatedAgentPreviews =
				await get<Dtos.Agent.UserPreview.Get.Response[]>(`/v2/agents/user-previews`);
			queryClient.setQueryData(agentPreviewsQueryKey(), updatedAgentPreviews);
		},
	});

	return {
		inviteAgentUser: mutation.mutate,
		inviteAgentUserIsLoading: mutation.isPending,
		inviteAgentUserError: mutation.error,
		inviteAgentUserIsSuccess: mutation.isSuccess,
	};
};
